// ExcludedProductIds.js
// Array of MongoDB product IDs to exclude from database fetches
// These products should not be fetched from MongoDB (only from Kroger API)
//
// Usage:
//   Add product IDs (as strings) to this array to prevent fetching them from the database

const excludedProductIds = [
  "65ebf6010b09184c8a15fc87", // Product no longer served from MongoDB
];

export default excludedProductIds;

